/* @flow */

import React, { Component } from 'react';
import { Modal, Button, Form } from 'semantic-ui-react';
import { tryExtractId } from 'utils/youtube';

type Props = {
  open: boolean,
  onSelected: (name: string, id: string, message?: string) => void,
  onClose: () => void,
};

type State = {
  name?: string,
  message?: string,
  youtubeValue?: string,
  youtubeId?: string,
};

class AddYoutubeModal extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  onNameChanged = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      const { value } = event.target;

      this.setState({
        name: value,
      });
    }
  };

  onMessageChanged = (event: SyntheticEvent) => {
    this.setState({
      message: event.target.value,
    });
  };

  onUrlChanged = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      const { value } = event.target;

      const youtubeId = tryExtractId(value);

      this.setState({
        youtubeId,
        youtubeValue: value,
      });
    }
  };

  render() {
    const { name, message, youtubeId, youtubeValue } = this.state;
    const { open, onSelected, onClose } = this.props;

    const confirm = () => {
      if (name && youtubeId) {
        onSelected(name, youtubeId, message);
      }
    };

    const canSubmit = youtubeId && youtubeId.length && name && name.length;

    return (
      <Modal closeIcon size="small" open={open} onClose={onClose}>
        <Modal.Header>Ajouter une vidéo Youtube</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Input
              error={(name && name.length === 0) || false}
              label="Nom"
              placeholder="Nom de la vidéo"
              value={name || ''}
              onChange={this.onNameChanged}
            />
            <Form.Input
              error={(youtubeValue && !youtubeId) || false}
              label="Lien vidéo Youtube"
              placeholder="https://www.youtube.com/watch?v="
              value={youtubeValue || ''}
              onChange={this.onUrlChanged}
            />
            <Form.TextArea
              label="Message"
              placeholder="Message de la vidéo"
              value={message || ''}
              onChange={this.onMessageChanged}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Annuler</Button>
          <Button
            disabled={!canSubmit}
            onClick={confirm}
            primary
            icon="plus"
            labelPosition="right"
            content="Ajouter"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default AddYoutubeModal;



// WEBPACK FOOTER //
// ./src/modules/my-space/components/AddYoutubeModal.js